<template>
    <div>
        <link href="https://img2.233.com/wx/union/pc/fine/category/css/jianli.css" rel="stylesheet" type="text/css">
        <div class="wx-header-cont" id="wx-header-cont"> 
        <!-- 添加white-skin白色皮肤，去掉既黑色皮肤 -->
        <div class="wx-header-container">
            <div class="fl-box">
          <h1 class="logo"> <a href="/"><img  :src="logo" > </a> </h1>
            <div class="line"></div>
            <div class="wx-subject">
                <h2>监理工程师</h2>
                <i class="dropdown-arrow"></i>
                <div class="subject-list">
                        <a href="./#/jianli">监理工程师</a>
                        <a href="./#/aq">安全工程师</a>
                        <a href="./#/cfe">一级消防工程师</a>
                        <a href="./#/zaojia">造价工程师</a>
                        <a href="./#/jzs1">一级建造师</a>
                        <a href="./#/jzs2">二级建造师</a>
                        <a href="./#/zjy">二级造价工程师</a>
                        <a href="./#/zjxfy">消防设施操作员</a>
                </div>
            </div>
            <div class="head-area  text-gry6 font14 fl m-t-10"  style="display: none;"> 当前地区
                <p class="m-l-15  bg-white fr "><em class="now-area p-0-20">全国版</em><a href="" class="more-area p-0-10">更多地区 </a></p>
                <div class="area_list">
                <ul>
                    <li><a href="/tegang/guojia/#tgtc">全国</a></li>
                    <li><a href="/tegang/shanxi1/#tgtc">陕西</a></li>
                    <li><a href="/tegang/hebei/#tgtc">河北</a></li>
                    <li><a href="/tegang/henan/">河南</a></li>
                    <li><a href="/tegang/sichuan/#tgtc">四川</a></li>
                    <li><a href="/tegang/jiangxi/#tgtc">江西</a></li>
                    <li><a href="/tegang/yunnan/#tgtc">云南</a></li>
                    <li><a href="/tegang/heilongjiang/#tgtc">黑龙江</a></li>
                    <li><a href="/tegang/chongqing/#tgtc">重庆</a></li>
                    <li><a href="/tegang/hubei/#tgtc">湖北</a></li>
                </ul>
                </div>
            </div>
            </div>
            <div class="fr-box"> 
                <!--未登录 -->
                <div class="personal-no" v-if="!isLogin">
                    <p><a target="_blank" :href="'/uc/login?redirecturl='+href" class="red">登录</a>|<a target="_blank" :href="'/uc/register?redirecturl='+href">注册</a></p>
                </div>
                <div class="personal" v-else>
                            <a href="javascript:;" class="pic"><img :src="logoSrc" ><i class="dropdown-arrow"></i></a>
                            <div class="pop-personal">
                                <a href="javascript:" @click="loginout()"><i class="icon"></i><span class="txt">退出</span></a>
                            </div>
                </div>
                <div class="classify"> 
                    <a class="classify-list" href="/shopping/cart" target="_blank" title="购课车">
                    <p class="icon shopping"></p>
                    </a> </div>
                <div v-if="kefu.length>0" class="wx-telephone">
                    <p class="txt1">客服热线</p>
                    <p class="txt2">{{kefu}}</p>
                </div>
            </div>
        </div>
        <div class="clear"></div>
        </div>
        <!--banner-->
        <div class="bg-black"> 
        <!--01banner-->
        <Banner imgUrl="https://img2.233.com/wx/union/pc/fine/category/img/jianli/banner01.jpg"></Banner>
        <!--01banner 结束--> 
        <!---02试听区域--->
        <div class="video clearfix">
            <div class="video-layout">
            <div class="subject-tabBox clearfix" >
                <ul class="sub-tabL clearfix">
                <li class="line" @click="changeCourseIndex(i)" v-for="(v,i) in courses.slice(0,4)" :key="i">
                    <a href="javascript: void(0)"  :class="i==courseIndex?'hover':''">{{v.name}}</a>
                </li>
                </ul>
                <div class="Rselect-box" @mouseover="changeIsHoverCourse(true)" @mouseout="changeIsHoverCourse(false)" >
                </div>
            </div>
            <myvideo   :isLogin="isLogin"  :allLoginPlayFlag="allLoginPlayFlag"  :unionId="unionId" :classEname="'jianli'" :logo="logo" :myClassId="courses[courseIndex].myClassId"></myvideo>
            </div>
            <div class="video-bottom"></div>
        </div>
        <!---02试听区域END---> 
        </div>
        <!--03原高级平台班级对比-->
        <banjiduibi :calssName="'监理工程师'" :classEName="'jianli'"></banjiduibi>
        <!--03原高级平台班级对比 end--> 
            
        <!--04全部班级表格-->
        <quanbubanji :classEname="'jianli'"></quanbubanji>
        <!--04全部班级表格 end--> 
        <!--06套用官网内容  开始-------------> 
        <!-- 证书价值 -->
        <div class="value_box_box" id="zsjz">
            <!-- 标题 -->
            <div class="headbox clearfix">
            <h3 class="head-title">
                <i class="numb_txt">02</i>证书价值
            </h3>
            <i class="title_bgnumb"></i>
            <span class="head-content"><em class="material-icon"></em>国家扩大需求，众多监理企业争取的对象<em class="material-icon02"></em></span>
            </div>
            <!-- 标题end -->
            <!-- 内容 -->
            <div class="value_content_txt">
            <ul>
                <li class="clearfix">
                <div class="employment_good_content">
                    <p class="main-txt">就业形势好</p>
                    <i class="pic_good"></i>
                </div>
                <div class="content_txt">
                    <p>全国6200多家各种资质的监理企业，每3万平方米必须约5个以上监理人员，全国各省约<i>需监理人才60w</i>，监理工程师存在巨大缺口，<i>工资呈上涨趋势</i></p>
                </div>
                </li>
            </ul>

            <ul>
                <li class="value_li clearfix">
                <div class="employment_good_content ">
                    <p class="main-txt">发展前景广阔</p>
                    <i class="pic_good pic_good02"></i>
                </div>
                <div class="content_txt">
                    <p>国家注册监理工程师8万余人，在建工程保持在10余万个左右，每3个工程才有1个注册监理工程师，<i>物以稀为贵，监理工程师当然前景广阔</i></p>
                </div>
                </li>
            </ul>

            <ul>
                <li class=" clearfix">
                <div class="employment_good_content clearfix">
                    <p class="main-txt">证书价值高</p>
                    <i class="pic_good pic_good03"></i>
                </div>
                <div class="content_txt">
                    <p>从事监理工作必备证书，岗位加薪、能力判断的重要依据，报考门槛高于一级、二级建造师，<i>证书含金量也更高</i></p>
                </div>
                </li>
            </ul>

            </div>


        </div>
        <!-- 证书价值end -->
        <!-- 授课体系 -->
        <div class="wx-course gray2-course" id="sktx">
        <div class="wx-mian wx-raiders">
            <!-- 标题 -->
            <div class="headbox clearfix">
            <h3 class="head-title head-title_dark">
                <i class="numb_txt numb_txt_white">03</i>授课体系
            </h3>
            <i class="title_bgnumb title_bgnumb_dark"></i>
            <span class="head-content head-content-dark"><em class="material-icon material-icon-dark"></em>3大阶段科学备考，零基础稳步提分<em class="material-icon02 material-icon02-dark"></em></span>
            </div>
        <!-- 标题end -->

        <div class="review clearfix" data-type="{cs1:'raiders-step-selected',tlist:'.raiders-step li',clist:'.raiders-bj'}" node-type="menu-tab" style="margin: 40px auto 0px;">
            <ul class="raiders-step fl">
                <li :class="skIndex==0?'raiders-step-selected':''" @mouseover="changeSkIndex(0)"><p>基础阶段</p></li>
                <li :class="skIndex==1?'raiders-step-selected':''" @mouseover="changeSkIndex(1)"><p>强化阶段</p></li>
                <li :class="skIndex==2?'raiders-step-selected':''" @mouseover="changeSkIndex(2)"><p>冲刺阶段</p></li>
            </ul>
            
            <div class="raiders-bj fl" v-show="skIndex==0">
                
                <div class="raiders-list raiders-list-top fl" style="border-bottom: 1px solid #f1f1f1;padding-bottom: 20px;">
                <dl class="raiders-list-dl fl">
                <dt><b></b><em class="digital-one">01</em><span>教材精讲班</span></dt>
                <dd>细致讲解教材各章节知识点，理清知识框架。帮助考生牢固夯实基础。</dd>
                    </dl>
                <ul class="raiders-list-ul fl"> 
                <li><b>学习效果<i></i></b><span class="raiders-red">掌握90%教材考点，全面夯实基础。</span></li>
                <li><b>课程时长<i></i></b><span>15-25小时/科</span></li>
                </ul>
                </div>

                <div class="raiders-list fl">
                <dl class="raiders-list-dl fl">
                <dt><b></b><em class="digital-two">02</em><span>习题班</span></dt>
                <dd>针对性讲解具有代表性的典型习题，分析出题方向，总结各题型答题技巧。</dd>
                    </dl>
                <ul class="raiders-list-ul fl"> 
                <li><b>学校效果<i></i></b><span class="raiders-red">掌握解题套路，短期内快速提升做题正确率。</span></li>
                <li><b>课程时长<i></i></b><span>5小时/科</span></li>
                </ul>
                </div>

            
            <div class="raiders-score-r">
                <p class="score-top">高效攻克<br><b>90%</b><span>知识点</span></p>
                <p class="score-bottom"><i class="score-jian"></i><i class="score-dian"></i><span>拿下<br><b>50</b>分</span></p>
            </div>
            </div>
            
            <div class="raiders-bj fl" v-show="skIndex==1">
                
                <div class="raiders-list raiders-list-top fl" style="border-bottom: 1px solid #f1f1f1;padding-bottom: 20px;">
                <dl class="raiders-list-dl fl">
                <dt><b></b><em class="digital-three">03</em><span>考点强化班</span></dt>
                <dd>结合思维导图，对重要考点进行拆分详解，强化巩固考点记忆。</dd>
                    </dl>
                <ul class="raiders-list-ul fl"> 
                <li><b>学习效果<i></i></b><span class="raiders-red">牢记60%高出题率关键得分点。</span></li>
                <li><b>课程时长<i></i></b><span>3小时/科</span></li>
                </ul>
                </div>
            
            <div class="raiders-list raiders-list-top fl" style="padding-bottom: 20px;">
                <dl class="raiders-list-dl fl">
                <dt><b></b><em class="digital-four">04</em><span>专题班</span></dt>
                <dd>集中讲解案例分析、三控两科重难点，针对性突破计算难题。</dd>
                    </dl>
            <ul class="raiders-list-ul fl"> 
                <li><b>学习效果<i></i></b><span class="raiders-red">掌握各类型计算题高效解题技巧。</span></li>
                <li><b>课程时长<i></i></b><span>8-10小时/科</span></li>
                </ul>
            </div>
            
            <div class="raiders-score-r">
                <p class="score-top">强化突破<br><b>60%</b><span>关键点</span></p>
                <p class="score-bottom score-bottom2"><i class="score-jian"></i><i class="score-dian"></i><span>拿下<br><b>30</b>分</span></p>
            </div>
            </div>
            
            <div class="raiders-bj fl" v-show="skIndex==2">
                
                
                <div class="raiders-list raiders-list-top fl" style="border-bottom: 1px solid #f1f1f1;padding-bottom: 20px;">
                <dl class="raiders-list-dl fl">
                <dt><b></b><em class="digital-five">05</em><span>考题突击班</span></dt>
                <dd>讲解2套高含金量考题突击卷，预测考试方向及趋势。</dd>
                    </dl>
                <ul class="raiders-list-ul fl"> 
                    <li><b>学习效果<i></i></b><span class="raiders-red">抢先做真正的“考题”，实现短期快速冲分。</span></li>
                    <li><b>课程时长<i></i></b><span>4小时/科</span></li>
                </ul>
                </div>
            
            <div class="raiders-list raiders-list-top fl">
                <dl class="raiders-list-dl fl">
                <dt><b></b><em class="digital-six">06</em><span>真题解析班</span></dt>
                <dd>视频解析历年考试真题试卷，分析总结高出题率考点。</dd>
                    </dl>
            <ul class="raiders-list-ul fl"> 
                    <li><b>学习效果<i></i></b><span class="raiders-red">查漏补缺，同时再次强化巩固高频考点。</span></li>
                    <li><b>学习时间<i></i></b><span>2-5小时/科</span></li>
                </ul>
                </div>

            <div class="raiders-score-r">
                <p class="score-top">高效预测<br><b>40%</b><span>考点</span></p>
                <p class="score-bottom score-bottom3"><i class="score-jian"></i><i class="score-dian"></i><span>稳拿<br><b>20</b>分</span></p>
            </div>
            </div>
            
        </div>
            
            </div>
        </div>
        <!-- 授课体系end -->
        <!-- 考点解密 -->
        <div class="vido_kebg" id="kdjm">
        <!-- 标题 -->
            <div class="headbox clearfix">
            <h3 class="head-title head-title_dark">
                <i class="numb_txt numb_txt_white">04</i>考点解密
            </h3>
            <i class="title_bgnumb title_bgnumb_dark"></i>
            <span class="head-content head-content-dark"><em class="material-icon material-icon-dark"></em>教学坚持“干货法则”，讲解全科教材考点<em class="material-icon02 material-icon02-dark"></em></span>
            </div>
        <!-- 标题end -->
        <div class="table_box">
            <ul>
            <li :class="kdIndex==0?'org_txt':''" @mouseover="changeKdIndex(0)">理论与法规</li>
            <li :class="kdIndex==1?'org_txt':''" @mouseover="changeKdIndex(1)">合同管理</li>
            <li :class="kdIndex==2?'org_txt':''" @mouseover="changeKdIndex(2)">三控</li>
            <li :class="kdIndex==3?'org_txt':''" @mouseover="changeKdIndex(3)">案例分析</li>
            </ul>
        </div>
        <div class="exam_box clearfix" v-show="kdIndex==0">
            <div class="exam_box_lf"><img src="https://img2.233.com/wx/union/pc/fine/category/img/jianli/img01.png" width="490" height="502" original="img/jianli/img01.png" style="display: inline;"></div>
            <div class="exam_box_rt"> <span><i></i><b>复习攻略</b> </span>
            <p>本科目<font style="color:#FF0000">第一章篇幅小，分值高</font>，考点明确，应重点掌握。第二章篇幅大，分值分散，尤其是法律法规内容虽分散，但在案例科目经常考核，有必要都掌握。 </p>
            <p>第三章分值不高，篇幅小，容易得分，掌握好企业（资质管理）、人员（注册形式）等内容即可。</p>
            <p>第四章与案例科目无大关系，掌握招标形式、建设工程监理实施方案等清晰考点即可。</p>
            <p>另外，第六章和第八章在案例中会考核到的内容需掌握。</p>
            </div>
        </div>
        <div class="exam_box clearfix" v-show="kdIndex==1">
            <div class="exam_box_lf"><img src="https://img2.233.com/wx/union/pc/fine/category/img/jianli/img02.png" width="490" height="502" original="img/jianli/img02.png"></div>
            <div class="exam_box_rt"> <span><i></i><b>复习攻略</b> </span>
            <p>本科目中<font style="color:#FF0000">第六章为重要的章节</font>，考察是订立施工合同时应约定的内容；履行合同中双方的职责和违约责任。</p>
            <p>第二章、第三章也是章节，内容为合同法律关系、合同担保，招标方式、招标程序、资格审查方法和评标价法等内容。</p>
            <p>另外，第七章的依据为《建设工程项目总承包管理规范》（GB50358-2005），为设计施工总承包合同履行中各方的职责和违约责任。</p>
            </div>
        </div>
        <div class="exam_box clearfix" v-show="kdIndex==2">
            <div class="exam_box_lf"><img src="https://img2.233.com/wx/union/pc/fine/category/img/jianli/img04.png" width="490" height="502" original="img/jianli/img04.png"></div>
            <div class="exam_box_rt"> <span><i></i><b>复习攻略</b></span>
            <p>质量控制分值：第一章（14-15%），第二章（10-11%），第三章（15-16%），第四章（25%），第六章（14-15%），以上章节分值较高，需把握。</p>
            <p>投资控制科目注重基本理论的考察，<font style="color:#FF0000">投资构成、工程量清单、合同价款调整、索赔</font>仍然是重中之重。</p>
            <p>进度控制的工程进度目标的论证，实际进度与计划进度的比较方法（横道图、S曲线、前锋线）等核心考点，应复习。</p>
            </div>
        </div>
        <div class="exam_box clearfix" v-show="kdIndex==3">
            <div class="exam_box_lf"><img src="https://img2.233.com/wx/union/pc/fine/category/img/jianli/img03.png" width="490" height="502" original="img/jianli/img03.png"></div>
            <div class="exam_box_rt"> <span><i></i><b>复习攻略</b> </span>
            <p>案例分析是对其他三科内容的总结，务必在系统学习其他三科知识以后，再复习该科目。</p>
            <p>案例的复习需注意深度，<font style="color:#FF0000">关注判断题、纠错题、计算题和程序题</font>，补充和列举题不必要求太高。</p>
            <p>此外，应注重历年真题，案例与其他三科不同，不仅要熟悉，还必须重复练习作答，练习组织语言，会用关键词，能长时间书写。</p>
            </div>
        </div>
        </div>
        <!-- 考点解密 end -->
        <!-- 师资团队 -->
        <div class="wx-course dark-ls-course" id="sztd">
        <!-- 标题 -->
            <div class="headbox clearfix">
            <h3 class="head-title">
                <i class="numb_txt">05</i>师资团队
            </h3>
            <i class="title_bgnumb"></i>
            <span class="head-content"><em class="material-icon"></em>他们更懂考试，为你的学习保驾护航<em class="material-icon02"></em></span>
            </div>
            <!-- 标题end -->

        <div class="m-teacher">
            <div class="wx-mian wx-mian-teacher" data-type="{cs1: 'teacher-li',tlist: '.teacher-ul li',clist: '.teacher-yr'}" node-type="menu-tab">
                <div class="dei"></div>
                <div class="teacher-team" style=" display: no ne">
                    <h5 class="h5-teacher">
                        <b>监理师资团队</b>
                        <span>TEACHER TEAM</span>
                        <i class="teacher-ione"></i>
                        <i class="teacher-itwo">郭炜、车龙兰助你轻松学考点</i>
                    </h5>
                    <ul class="teacher-ul">
                        <li :class="teacherIndex==0?'teacher-li':''" @mouseover="changeTeacherIndex(0)">
                            <img src="https://img2.233.com/wx/union/pc/fine/category/img/jianli/gw_small.png"  alt="" data-lzled="true"  style="display: inline;">
                        </li>
                        <li :class="teacherIndex==1?'teacher-li':''" @mouseover="changeTeacherIndex(1)">
                            <img src="https://img2.233.com/wx/union/pc/fine/category/img/jianli/cll_small.png"  alt="" data-lzled="true"  style="display: inline;">
                        </li>
                        <li :class="teacherIndex==2?'teacher-li':''" @mouseover="changeTeacherIndex(2)">
                            <img src="https://img2.233.com/wx/union/pc/fine/category/img/jianli/lzj_small.png" alt="" data-lzled="true"  style="display: inline;">
                        </li>
                        <li :class="teacherIndex==3?'teacher-li':''" @mouseover="changeTeacherIndex(3)">
                            <img src="https://img2.233.com/wx/union/pc/fine/category/img/jianli/zch_small.png" alt="" data-lzled="true"  style="display: inline;">
                        </li>
                        <li :class="teacherIndex==4?'teacher-li':''" @mouseover="changeTeacherIndex(4)">
                            <img src="https://img2.233.com/wx/union/pc/fine/category/img/jianli/jlj_small.png" alt="" data-lzled="true"  style="display: inline;">
                        </li>
                        <li :class="teacherIndex==5?'teacher-li':''" @mouseover="changeTeacherIndex(5)">
                            <img src="https://img2.233.com/wx/union/pc/fine/category/img/jianli/wdx_small.png" alt="" data-lzled="true"  style="display: inline;">
                        </li>
                    </ul>
                </div>

                <div class="teacher-yr" v-show="teacherIndex==0">
                    <div class="kqquan"></div>
                    <div class="teacher-tops clearfix">
                        <div class="teacher-yr-img fl">
                            <img src="https://img2.233.com/wx/union/pc/fine/category/img/jianli/gw_big.png" alt="" data-lzled="true"  style="display: inline;">
                        </div>
                        <div class="teaching-box fl">
                            <div class="teaching-age">
                                <h5 class="teaching-h5">郭炜老师</h5>
                                <p>
                                    <span class="jz-name">
                    经验丰富，干净利索、分析到位的培训达人。</span>
                                </p>
                            </div>
                            <h5 class="speaker-h5">主讲科目</h5>
                            <ul class="teaching-speaker">
                                <li>
                                    <span>《建设工程监理案例分析》</span>
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div class="teaching-evaluation">
                        <h5 class="speaker-h5">专业背景</h5>
                        <p>博士，985名校副教授，一级建造师，造价工程师。</p>
                    </div>
                    <div class="teaching-evaluation teaching-evaluations">
                        <h5 class="speaker-h5">学员评价</h5>
                        <p>听郭炜老师的课就像看连续剧，干净利索，分析到位，思路灵活，富有激情，让人印象深刻。</p>
                    </div>
                </div>

                <div class="teacher-yr" v-show="teacherIndex==1">
                    <div class="kqquan"></div>
                    <div class="teacher-tops clearfix">
                        <div class="teacher-yr-img fl">
                            <img src="https://img2.233.com/wx/union/pc/fine/category/img/jianli/cll_big.png"  alt="">
                        </div>
                        <div class="teaching-box fl">
                            <div class="teaching-age">
                                <h5 class="teaching-h5">车龙兰老师</h5>
                                <p>
                                    <span class="jz-name">
                    能将知识点清晰化，重点突出化、难点简单化。</span>
                                </p>
                            </div>
                            <h5 class="speaker-h5">主讲科目</h5>
                            <ul class="teaching-speaker">
                                <li>
                                    <span>《建设工程投资控制》</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="teaching-evaluation">
                        <h5 class="speaker-h5">专业背景</h5>
                        <p>一级建造师、资深讲师。</p>
                    </div>
                    <div class="teaching-evaluation teaching-evaluations">
                        <h5 class="speaker-h5">学员评价</h5>
                        <p>车老师能把知识点进行前后关联，思路清晰，层次清晰，易于理解记忆。例题讲得恰到好处，有方法有技巧。</p>
                    </div>
                </div>

                <div class="teacher-yr" v-show="teacherIndex==2">
                    <div class="kqquan"></div>
                    <div class="teacher-tops clearfix">
                        <div class="teacher-yr-img fl">
                            <img src="https://img2.233.com/wx/union/pc/fine/category/img/jianli/lzj_big.png" alt="" >
                        </div>
                        <div class="teaching-box fl">
                            <div class="teaching-age">
                                <h5 class="teaching-h5">刘志军老师</h5>
                                <p>
                                    <span class="jz-name">
                    能把握考试重难点，并辅以记忆法，有效减轻学员的学习负担。</span>
                                </p>
                            </div>
                            <h5 class="speaker-h5">主讲科目</h5>
                            <ul class="teaching-speaker">
                                <li>
                                    <span>《建设工程进度控制》</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="teaching-evaluation">
                        <h5 class="speaker-h5">专业背景</h5>
                        <p>国家注册一级建造师、造价工程师。</p>
                    </div>
                    <div class="teaching-evaluation teaching-evaluations">
                        <h5 class="speaker-h5">学员评价</h5>
                        <p>刘老师的课听多少遍都不觉得枯燥，该仔细的地方讲的非常透彻。有深度，专业细致，易学好懂，具体生动。</p>
                    </div>
                </div>

                <div class="teacher-yr" v-show="teacherIndex==3">
                    <div class="kqquan"></div>
                    <div class="teacher-tops clearfix">
                        <div class="teacher-yr-img fl">
                            <img src="https://img2.233.com/wx/union/pc/fine/category/img/jianli/zch_big.png"  alt="" >
                        </div>
                        <div class="teaching-box fl">
                            <div class="teaching-age">
                                <h5 class="teaching-h5">张程华老师</h5>
                                <p>
                                    <span>授课方式思路清晰，举一反三，逻辑性强，浅显易懂。</span>

                                </p>
                            </div>
                            <h5 class="speaker-h5">主讲科目</h5>
                            <ul class="teaching-speaker">

                                <li>
                                    <span>《建设工程合同管理》 </span>
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div class="teaching-evaluation">

                        <h5 class="speaker-h5">专业背景</h5>
                        <p>博士，讲师、建造工程师。</p>
                    </div>
                    <div class="teaching-evaluation teaching-evaluations">
                        <h5 class="speaker-h5">学员评价</h5>
                        <p>讲课相当精炼，没有废话，重点突出。例题与注解明确清晰，处处讲到点子上，很会教学生如何应考。</p>

                    </div>
                </div>

                <div class="teacher-yr" v-show="teacherIndex==4">
                    <div class="kqquan"></div>
                    <div class="teacher-tops clearfix">
                        <div class="teacher-yr-img fl">
                            <img src="https://img2.233.com/wx/union/pc/fine/category/img/jianli/jlj_big.png"  alt="" >
                        </div>
                        <div class="teaching-box fl">
                            <div class="teaching-age">
                                <h5 class="teaching-h5">江凌俊老师</h5>
                                <p>
                                    <span>授擅长辅导零基础、非专业的学员</span>

                                </p>
                            </div>
                            <h5 class="speaker-h5">主讲科目</h5>
                            <ul class="teaching-speaker">

                                <li>
                                    <span>《建设工程质量控制》 </span>
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div class="teaching-evaluation">

                        <h5 class="speaker-h5">专业背景</h5>
                        <p>从事建筑类培训多年</p>
                    </div>
                    <div class="teaching-evaluation teaching-evaluations">
                        <h5 class="speaker-h5">学员评价</h5>
                        <p>用通俗的语言解释专业，用形象的方法记忆考点。对考试重点把握稳、准、狠。</p>

                    </div>
                </div>

                <div class="teacher-yr" v-show="teacherIndex==5">
                    <div class="kqquan"></div>
                    <div class="teacher-tops clearfix">
                        <div class="teacher-yr-img fl">
                            <img src="https://img2.233.com/wx/union/pc/fine/category/img/jianli/wdx_big.png" alt="" >
                        </div>
                        <div class="teaching-box fl">
                            <div class="teaching-age">
                                <h5 class="teaching-h5">王东兴老师</h5>
                                <p>
                                    <span>授课挥洒自如，思路清晰，口齿伶俐</span>

                                </p>
                            </div>
                            <h5 class="speaker-h5">主讲科目</h5>
                            <ul class="teaching-speaker">

                                <li>
                                    <span>《基本理论与相关法规》</span>
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div class="teaching-evaluation">

                        <h5 class="speaker-h5">专业背景</h5>
                        <p>管理学硕士，“灵魂导师”</p>
                    </div>
                    <div class="teaching-evaluation teaching-evaluations">
                        <h5 class="speaker-h5">学员评价</h5>
                        <p>举例生动易懂，对理解上很大帮助。恰到好处的选取考试重点，帮考生过滤掉不重要知识点。</p>

                    </div>
                </div>


            </div>
        </div>
        </div>
        <!-- 师资团队 end -->






        <!--06套用官网内容  end-------------> 
        <!--05服务特色标题-->
        <div class="main-title f-tac m-b-30 p-t-50" >
        <p class="font-bg">CHARACTERISTIC</p>
        <h2 class="font44 fb">选择我们的<em class="text-red fb">四大理由</em></h2>
        <p class="font17 text-gry-6 lh2">服务保障，学习无忧，通关指日可待</p>
        </div>
        <div class="fuwu-bg ">
        <div class="fuwu-content">
            <div class="fuwu-box">
            <ul class="clearfix m-b-20">
                <li>
                <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">1</span>课程品质高</h4>
                <p class="font15 lh2 p-15">课程专业的教研团队精心打造，<em class="text-red fb">每个课程均经过20+次以上迭代</em>。</p>
                </li>
                <li>
                <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">2</span>老师实力强</h4>
                <p class="font15 lh2 p-15">网校执行严格的<em class="text-red fb">师资淘汰制，由购课学员评分</em>，努力建设零差评老师团队。</p>
                </li>
                <li>
                <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">3</span>学习服务优</h4>
                <p class="font15 lh2 p-15">您在学习课程中遇到任何问题，可在线提问，专业老师<em class="text-red fb">24小时内为您答疑解惑</em>。</p>
                </li>
                <li>
                <h4 class="f-tac fb font24 m-b-20"><span class="m-r-5 bg-sblue">4</span>售后服务好</h4>
                <p class="font15 lh2 p-15">部分套餐课程享<em class="text-red fb">超长有效期</em>，课程有效期内考试<em class="text-red fb">不过免费重学</em>保障。</p>
                </li>
            </ul>
            </div>
            
            
        </div>
        </div>
        <!--05服务特色 end--> 
    </div>
</template>
<script>
import myvideo from '@/components/myvideo'
import banjiduibi from '@/components/banjiduibi'
import quanbubanji from '@/components/quanbubanji'
import { getMemberPicpath } from '@/request/request.js'
export default {
  name: 'App',
  components: {
    banjiduibi,
    quanbubanji,
    myvideo
  },  
  data() {
    return {
      laoshiindex:0,
      isLogin:false,
      logoSrc:"",
      allLoginPlayFlag:false,
      unionId:"",
      kefu:"",
      logo:"",
      href:"",
      courses:[
        {name:'目标控制（土建）',myClassId:28815},
        {name:'案例分析（土建）',myClassId:28817},
        {name:'合同管理',myClassId:28819},
        {name:'理论与法规',myClassId:28818},
      ],
      courseIndex:0,
      isHoverCourse:false,
      teachers:[
            {                  
                img:"t-teacher-da1.jpg",
                name:"黄明峰老师",
                jieshao:'<span class="jz-name"><em>13</em>年建筑类教学经验</span><span><em>5</em>年消防教学经验</span>',
                zhujiang:["技术实务","综合能力","案例分析"],
                zhuanye:"网校独家主讲3科，一级消防工程师，一级建造师，造价工程师，建设工程造价协会理事",
                pingjia:"黄老师是消防培训界可以封“神”的人物。讲课通俗易懂，生动形象而不照本宣科，太过瘾了。"
            },
      ],
      teacherIndex:0,
      kdIndex:0,
      skIndex:0,
    };
  },
  created(){
    this.href=encodeURIComponent(window.location.href);
    var config=JSON.parse(sessionStorage.getItem(window.location.host+"puconfig"));
    if(config.KefuTelList.length>0){
      this.kefu=config.KefuTelList[0].KefuNumber;
    }
    this.unionId=config.UnionId
    this.logo=config.UnionLogo;
    this.allLoginPlayFlag=config.AllLoginPlayFlag;
    var token = localStorage.getItem("usertoken");
    if(token!=undefined){
        this.isLogin=true;
        getMemberPicpath({},(res)=>{
            this.logoSrc=res;
        });
    }else{
        var interval= setInterval(() => {
        token = localStorage.getItem("usertoken");
        if(token!=undefined){
          this.isLogin=true;
          getMemberPicpath({},(res)=>{
            this.logoSrc=res;
          });
          clearInterval(interval);
        }
      }, 200);
    }
  },
  methods:{
      loginout(){
          this.isLogin=false;
          this.logoSrc="";
          localStorage.removeItem("usertoken");
      },
      scroll(num){
        document.documentElement.scrollTop=num;
      },
     changeCourseIndex(i){
       this.courseIndex=i;
     },
    changeIsHoverCourse(flag){
      this.isHoverCourse=flag;
    },
    changehoverindex(i){
      this.hoverindex=i;
    },
    changeTeacherIndex(i){
      this.teacherIndex=i;
    },
    changeKdIndex(i){
        this.kdIndex=i;
    },
    changeSkIndex(i){
        this.skIndex=i;
    }
  },
}
</script>